"use strict";
import { UniverseChainId } from "features/chains/types";
import { getBscContracts } from "constants/bscContracts";
import {
  BTCB_BSC_TESTNET,
  ETH_BSC_TESTNET,
  USDC_BSC_MAINNET,
  USDC_BSC_TESTNET,
  USDT_BSC_MAINNET,
  USDT_BSC_TESTNET
} from "constants/topazTokenList";
const PLACEHOLDER = "0x0000000000000000000000000000000000000000";
export function getCommonIntermediaries(chainId) {
  const effectiveChainId = chainId || UniverseChainId.Mainnet;
  const contracts = getBscContracts(effectiveChainId);
  const WBNB = contracts?.wbnb?.toLowerCase() || PLACEHOLDER;
  const TOPAZ = contracts?.topaz?.toLowerCase() || PLACEHOLDER;
  if (effectiveChainId === UniverseChainId.Mainnet) {
    return [
      WBNB,
      USDC_BSC_MAINNET.address.toLowerCase(),
      USDT_BSC_MAINNET.address.toLowerCase(),
      TOPAZ
    ].filter((addr) => addr !== PLACEHOLDER);
  }
  return [
    WBNB,
    USDC_BSC_TESTNET.address.toLowerCase(),
    USDT_BSC_TESTNET.address.toLowerCase(),
    ETH_BSC_TESTNET.address.toLowerCase(),
    BTCB_BSC_TESTNET.address.toLowerCase(),
    TOPAZ
  ].filter((addr) => addr !== PLACEHOLDER);
}
